import listActions from '../../../modules/subcategory/list/subcategoryListActions'
import SubcategoryService from '../../../modules/subcategory/subcategoryService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'SUBCATEGORY_DESTROY'

const subcategoryDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subcategoryDestroyActions.DESTROY_STARTED,
      })

      await SubcategoryService.destroyAll([id])

      dispatch({
        type: subcategoryDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.subcategory.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/subcategory'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: subcategoryDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: subcategoryDestroyActions.DESTROY_ALL_STARTED,
      })

      await SubcategoryService.destroyAll(ids)

      dispatch({
        type: subcategoryDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.subcategory.destroyAll.success'),
      )

      dispatch(push('/subcategory'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: subcategoryDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default subcategoryDestroyActions
